import React from 'react';

import Header from '../../layout/Header.jsx';
import ListCompetitions from '../../lists/ListCompetitions.jsx';

const PageCompetitions = () => (
  <div>
    <Header>Competitions</Header>
    <ListCompetitions />
  </div>
);

export default PageCompetitions;
